import { FloatingFormItem } from '@/components/_common';
import { Form, Row, Col, Input, Button } from 'antd';
import EmailEditor from '../EmailEditor';
import { useDefaultEmptyFieldError, useWindowSize } from '@/hooks';
import QuizzesSelect from '@/components/_common/QuizzesSelect';
import { useEmailTagsByType } from '@/core/domain/crm/EmailTags/EmailTags.hooks';
import {
  SendOption,
  SendOptionType,
} from '@/core/domain/crm/SendOptions/SendOptions.types';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import Authorities from '@/types/Authority';
import { ArrowRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';

interface Props {
  shippingOption?: SendOption;
  shippingType?: SendOptionType;
  loading?: boolean;
}

const ShippingOptionsEmailForm: React.FC<Props> = ({
  shippingOption,
  shippingType,
  loading,
}) => {
  const ruleRequired = useDefaultEmptyFieldError();
  const form = Form.useFormInstance();
  const quizId = Form.useWatch('quizId', form);
  const { isMobile } = useWindowSize();

  const { data: tagsByType } = useEmailTagsByType(shippingType);

  return (
    <>
      <Row gutter={[24, 12]}>
        <Col span={24} md={8}>
          <FloatingFormItem name="title" label="Título" rules={[ruleRequired]}>
            <Input disabled={shippingOption?.systemDefaultType} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem
            name="subject"
            label="Assunto"
            rules={[ruleRequired]}
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8}>
          <FloatingFormItem name="quizId" label="Questionário">
            <QuizzesSelect />
          </FloatingFormItem>
        </Col>
      </Row>

      <Form.Item name="body" label="Corpo do e-mail" rules={[ruleRequired]}>
        <EmailEditor tagsByType={tagsByType} quizId={quizId} key={quizId} />
      </Form.Item>

      <Row gutter={[24, 24]} justify="end">
        <Col
          style={{ marginTop: isMobile ? 90 : undefined }}
          span={isMobile ? 24 : undefined}
        >
          <ButtonBack path="/app/customers/crm/shippingOptions" />
        </Col>

        <Col
          style={{ marginTop: isMobile ? 90 : undefined }}
          span={isMobile ? 24 : undefined}
        >
          <Button
            htmlType="submit"
            disabled={!hasPermissions([Authorities.CRM_SENDOPTION_UPDATE])}
            loading={loading}
            block
          >
            <AntdFeatherIcon icon={<ArrowRight />} size={12} />

            <FormattedMessage id="shippingOptions.buttons.next" />
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ShippingOptionsEmailForm;
